import { createApi } from '@reduxjs/toolkit/query/react'

import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { proxySiteBuilder } from 'src/core/classes/helpers/UrlHelper'
import { IReference } from 'src/core/classes/models/IReference'

import { getCustomQuery } from './helpers/getCustomQuery'
import { getResponseHandler } from './helpers/getResponseHandler'

export const referenceLanguagesApi = createApi({
  reducerPath: '@app/api/referenceLanguages',
  baseQuery: getCustomQuery({
    storageKey: StorageKeys.languages,
    baseUrl: proxySiteBuilder('/mbe/api/v2/dictionaries/languages'),
  }),
  endpoints: (builder) => ({
    getReferenceLanguages: builder.query<IReference[], void>({
      query: () => {
        return {
          url: ``,
          responseHandler: getResponseHandler({
            storageKey: StorageKeys.languages,
            prepareValue: (items = []) => {
              return (items as IReference[]).map((row) => ({
                name: row['Name'],
                value: row['Value'],
              }))
            },
          }),
        }
      },
    }),
  }),
})

export const { useGetReferenceLanguagesQuery } = referenceLanguagesApi
